<template>
  <w-icon-wrapper
    :width="24.284"
    :height="24.194"
    icon-name="work-proposal-icon"
    viewBox="0 0 24.284 24.194"
  >
    <g
      id="_80_Vorschlag_Icon"
      data-name="80 Vorschlag_Icon"
      transform="translate(-298 -210.999)"
    >
      <path
        id="Pfad_55810"
        data-name="Pfad 55810"
        d="M8.722,19.68a.933.933,0,0,0,.931.931h3.722a.933.933,0,0,0,.931-.931v-.931H8.722ZM11.514,2A6.511,6.511,0,0,0,7.792,13.855v2.1a.933.933,0,0,0,.931.931h5.583a.933.933,0,0,0,.931-.931v-2.1A6.511,6.511,0,0,0,11.514,2Zm2.652,10.329-.791.558v2.14H9.653v-2.14l-.791-.558a4.653,4.653,0,1,1,5.3,0Z"
        transform="translate(298.583 214.583)"
        fill="currentColor"
      />
      <path
        id="Pfad_55811"
        data-name="Pfad 55811"
        d="M3.815,6.366,5.371,4.809,7.347,6.8,5.791,8.353Zm8.224-1h2.208V2.05H12.038ZM1,15.3H4.311V13.088H1Zm20.973,0h3.311V13.088H21.973Zm-3.047-8.51L20.9,4.8l1.556,1.556L20.472,8.331Z"
        transform="translate(297 208.949)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconProposal' };
</script>
